import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import AddModel from "../../components/Add/AddModel";
import { useState } from "react";
import MainTable from "../../components/tables/MainTable";
import endpoints from "../../services/endpoints";
import { TableDetailsItem } from "../../components/tables/tableFunctions";
import CustomModal from "../../components/CustomModal";
import useApi from "../../services/useApi";
import { useDispatch } from "react-redux";
import { showToast } from "../../components/toastMessage/toastSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { setMnoUrl } from "../../store/slices/geolocationSlice";
import { setActiveList } from "../../store/slices/activeListSlice";

export default function ListofPurchasedAmount() {
  const [showModel, setShowModel] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const list = useSelector((state: any) => state.list?.data);
  let { activeList } = useSelector((state: RootState) => state.activeList);
  const selectedTransaction = list?.find((item: any) => item.id === transactionId);
  const navigation = useNavigate();  const dispatch = useDispatch();
  const { PatchAPI } = useApi();
  const { manualEntries } = endpoints;
  const { id } = useParams();
  const [fetchListTrigger, setFetchListTrigger] = useState(false);
  const location = useLocation();
  const TableDetails: { [key: string]: TableDetailsItem } = {
    "Transaction ID": {
      id: "transaction_id",
    },
    "Processed Date": {
      id: "created_at",
      custom: ["created_at"],
    },
    ...(activeList === 'Purchased' && {"Purchased Date": {
      id: "purchased_date",
    }}),
    "Purchased Amount": {
      id: "purchased_amount",
    },
    ...(activeList === 'Purchased' ? {
      "Purchase Type": {
      id: "purchase_type",
    },
      "Transaction Receipt": {
      id: "receipt_url",
    },
    "Credit Status": {
      id: "credit_status",
    }}: {
      "Pending Amount": {
      id: "pending_amount",
    }
    }),
    Actions: {
      id: "actions",
      className: "min-w-[200px]", // Adding className here
      actionTypes: activeList === 'Purchased' ? ["upgrade", "view"] : ["payment"],
    },
  };

  const handleActions = async (dataId: string, key: string, text?: string) => {
    if (key === "upgrade") {
      setTransactionId(dataId);
      setShowModel(true);
    } else if (key === "view") {
      dispatch(setMnoUrl(location.pathname + location.search))
      navigation(`/mno-management/list-of-mnos/view-mno/${id}/purchased-amount-transaction/view-manual/${dataId}`);
    } else if (key === "payment") {
      navigation(`/mno-management/list-of-mnos/view-mno/${id}/purchased-amount-transaction/pay-due-bill/${dataId}`);
    }
  }

  const handleActiveList = (key: string) => {
    setFetchListTrigger(true)
    dispatch(setActiveList(key));
  };

  const handleStatus = async () => {
    setButtonLoading(true);
    // Perform the status update logic here
    let payload = {
      type: "Update Credit Status",
      details: {
        credit_status: true
      }
    };
    try {
      let response = await PatchAPI(`manual-entries/purchases/${transactionId}`, payload);
      if(!response.error){
        dispatch(showToast({type: "success", message: 'Credit status updated successfully'}));
        setShowModel(false);
        setButtonLoading(false);
        setFetchListTrigger(!fetchListTrigger);
      } else {
        dispatch(showToast({type: "error", message: response.data.message}));
        setShowModel(false);
        setButtonLoading(false);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
    
  }

  const addButtonClick = () => {
    navigation(`/mno-management/list-of-mnos/view-mno/${id}/purchased-amount-transaction/add-manual`);
  };
  const staticText = {
    emptyScreenText: {
      heading1: `There are no ${activeList.toLocaleLowerCase()} amount transaction added yet`,
      heading2: "Click “Add Manual” to create one",
    },
  };

  return (
    <div>
      <Breadcrumbs
        navPath={["MNO Management", "List of MNO's", "View Details", "List of Purchased Amount Transaction"]}
        heading="List of Purchased Amount Transaction"
        noNavigation
        links={["/mno-management/list-of-mnos", "/mno-management/list-of-mnos", `/mno-management/list-of-mnos/view-mno/${id}`, `/mno-management/list-of-mnos/view-mno/${id}/purchased-amount-transaction`]}
        button={{
          buttonName: "Add Manual",
          className: "w-[140px]",
          buttonOnclick: addButtonClick,
        }}
        hasAddPrivilege={true}
      />
      <MainTable
        staticText={staticText}
        mainEndPoint={`${manualEntries}${id}`}
        TableDetails={TableDetails}
        handleActions={handleActions}
        params={{ page_number: "1" }}
        searchPlaceholder={"Search by Transaction ID"}
        filters={true}
        exporting={true}
        hasListPrivilege={true}
        hasEditMDPrivilege={true}
        hasViewMDPrivilege={true}
        notfoundRoute={{ state: { route: '/mno-management/list-of-mnos' } }}
        amountList={true}
        fetchListTrigger={fetchListTrigger}
        handleActiveList={handleActiveList}
      />
      {showModel && (
        <CustomModal
          isOpen={showModel}
          onClose={() => setShowModel(false)}
          title={'Update Credit Status '}
          subText={`Are you sure you want to update the credit status for Transaction ID: ${selectedTransaction.transaction_id} to 'Received' for AFA ${selectedTransaction.purchased_amount}?`}
          primaryButtonText={'Update'}
          secondaryButtonText={'Cancel'}
          handelSubmit={handleStatus}
          buttonColor={'bg-p_primary'}
          // textArea={selectedAction === 'deactivate'}
          buttonLoading={buttonLoading}
          buttonWidth={'w-[108px]'}
        />
      )}
    </div>
  );
}